var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clinic-selector"},[_c('v-select',{staticClass:"wabident-selector",attrs:{"id":_vm.id,"options":_vm.clinics,"value":_vm.value,"reduce":x => x.value,"placeholder":_vm.placeholder},on:{"input":_vm.onInput}}),_vm._v(" "),_c('label',{staticClass:"wabident-info",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }